<template>

<div class="chart">

    <div class="chart-visual" ref="chart" />

    <div class="chart-key">

        <div class="chart-key-item" v-for="(item, index) in items" :key="index">

            <div class="chart-key-item-colour" />
            <div class="chart-key-item-name">{{ item.name }}</div>
            <div class="chart-key-item-value">{{ item.value | prettyNumber }}</div>

        </div>

    </div>

</div>

</template>

<script>

import ApexCharts from 'apexcharts'

export default {
	
    props: ['data'],

    computed: {

        items: function() {

            var items = []

            this.$_.each(this.data, function(item) {

                items.push({
                    name: item.name,
                    value: item.value
                })

            })

            return items

        },

        options: function() {

            var options = {
                series: [],
                labels: [],
                chart: {
                    type: 'donut',
                    height: '280px',
                    width: '280px'
                },
                colors: ['#14C6A4', '#89ead7'],
                legend: {
                    show: false
                }
            }

            this.$_.each(this.data, function(item) {

                options.series.push(item.value)
                options.labels.push(item.name)

            })

            return options

        }
        
    },

    created: function() {

        this.$nextTick(function() {

            this.build()

        }.bind(this))

    },

    methods: {

        build: function() {

            var chart = new ApexCharts(this.$refs.chart, this.options)

            chart.render()

        }

    }

}

</script>

<style scoped>

.chart {
    padding: 20px 0px;
    display: grid;
    grid-template-columns: 280px 1fr;
    grid-gap: 20px;
    align-items: center;
}

.chart-key-item {
    display: grid;
    grid-template-columns: 16px 1fr auto;
    align-items: center;
    grid-gap: 10px;
    padding: 10px 0px;
}

.chart-key-item-colour {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background-color: #efefef;
}

.chart-key-item:nth-child(1) .chart-key-item-colour {
    background-color: #14C6A4;
}

.chart-key-item:nth-child(2) .chart-key-item-colour {
    background-color: #89ead7;
}

.chart-key-item-name {
    font-size: 14px;
    font-weight: 700;
    color: #050505;
}

.chart-key-item-value {
    font-size: 14px;
    font-weight: 700;
    color: #050505;
}

</style>
